import { render, staticRenderFns } from "./PaymentTermsForm.vue?vue&type=template&id=45ee470c"
import script from "./PaymentTermsForm.vue?vue&type=script&lang=js"
export * from "./PaymentTermsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports